import { createFileRoute } from "@tanstack/react-router";
import Karriar from "@/pages/Karriar";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildPageSchema, buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/karriar")({
  head: () =>
    buildSeoHead(publicPageSeo.karriar, [
      buildPageSchema(publicPageSeo.karriar, "WebPage"),
      buildBreadcrumbSchema(getBreadcrumbTrail("/karriar") ?? []),
    ]),
  component: Karriar,
});
